import { PaymentMethodModel } from './payment-method.model';

export class PaymentMethodTypeModel {
  public id: number;
  public nombre: string;
  public descripcion: string;
  public fechaVigDesde: Date;
  public admiteCuotas: boolean;
  public mediosPagoList: Array<PaymentMethodModel>;

  constructor() {
    this.id = 0;
    this.nombre = '';
    this.descripcion = '';
    this.fechaVigDesde = new Date();
    this.admiteCuotas = false;
    this.mediosPagoList = [];
  }
}
